<template>
  <div v-if="inputedValue.dialog && pageData.length > 0">
    <MultipleAreaBase
      v-model="inputedValue"
      :width="width"
      :title="$t('storage.storage_stock-adjust-confirm')"
      :tables="pageData"
      :isExpansionPanelFooter="true"
    >
      <template v-slot:[pageData[0].name]>
        <ClientInfo :recItems="recItems" pageType="history" />
      </template>
      <template v-slot:[pageData[1].name]>
        <div class="productTableHeader">
          <ProductTable
            :headers="pageData[1].headers"
            :items="recItems.productMoves"
            item-key="product.productNumber"
            productKey="productMoveId"
          >
          </ProductTable>
        </div>
      </template>
      <template #expansionPanelFooter1>
        <v-container fluid>
          <v-row justify="end" class="ma-1">
            <div class="ma-2 btnStyle">
              <NormalButton
                v-if="authority.isAdmin"
                :text="$t('storage.storage_stock-adjust-cancel')"
                textSize="12px"
                height="32px"
                width="100%"
                btnClass="ml-auto"
                color="white"
                textColor="thinText--text"
                @click="cancel"
                :outlined="true"
              />
            </div>
            <div class="ma-2 ml-6 btnStyle">
              <NormalButton
                :text="$t('storage.storage_stock-adjust-adjust')"
                textSize="12px"
                height="32px"
                width="100%"
                btnClass="ml-auto"
                color="white"
                textColor="thinText--text"
                :outlined="true"
                @click="quickFix.dialog = true"
              />
              <QuickFixStockAdjustDialog
                v-model="quickFix"
                :title="$t('storage.storage_stock-adjust-adjust')"
                width="80%"
                :recItems="recItems"
                @dialogReload="dialogReload"
              />
            </div>
          </v-row>
        </v-container>
      </template>

      <template v-slot:[pageData[2].name]>
        <v-row class="mx-3 my-2">
          <v-col cols="6">
            <Remarks
              title=""
              text=""
              v-model="remarks"
              :isRegister="true"
              @updateRemarks="updateRemarks"
            />
          </v-col>
        </v-row>
      </template>
    </MultipleAreaBase>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import MultipleAreaBase from '../MultipleAreaBase'

import ClientInfo from '@/components/layouts/ClientConfirmation/StorageInfo/CustomerInfoBase'
import { QuickFixStockAdjustDialog } from '@/components/layouts/Dialogs'
import { storageUtil, stockAdjustUtil } from '@/util'

import {
  ProductTable,
  Remarks,
  QuantityRackNumber,
  NormalDatePicker
} from '@/components/items'

import NormalButton from '@/components/items/Buttons/NormalButton'

export default {
  components: {
    MultipleAreaBase,
    ClientInfo,
    // OperationDetail,
    QuickFixStockAdjustDialog,
    ProductTable,
    NormalButton,
    Remarks
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },
    recItems: {
      type: Object,
      require: false,
      default: () => ({})
    },

    // TODO：不要なら消す
    isHistoryType: { default: false },
    isFooter: { default: false },
    isEdit: { default: false },
    isTotalAmount: { default: true }
  },
  data: () => ({
    pageType: {
      en: 'sale',
      ja: '注文'
    },

    pageData: [],
    quickFix: { dialog: false },

    productInputData: [],
    productInputDataForShip: [],
    isPossibleOperation: true,
    loadingItems: [],

    remarks: ''
  }),
  methods: {
    ...mapActions('Stock', ['editStockAdjust', 'cancelStockAdjust']),
    // register() {
    //   this.$emit('register')
    // },
    // cancel(id) {
    //   this.$emit('cancel', id)
    // },
    // edit(rec) {
    //   this.$emit('edit')
    // }
    init() {
      this.pageData = [
        {
          title: 'storage.storage_stock-adjust-info',
          name: 'paymentInfo',
          items: [],
          itemKey: ''
        },
        {
          title: `${this.$t('common.input_sale-details')}（${
            storageUtil.getStorageById(this.recItems.adjustStorageId)?.name
          }）${stockAdjustUtil.getStockAdjustStatusName(this.recItems.status)}`,
          name: 'operationDetail',
          buttonAreaName: 'operationDetailbuttonArea',
          headers: [
            {
              text: 'product.product_product-number',
              value: 'product.productNumber',
              sortable: false,
              width: '7%',
              class: 'rgba(151, 198, 234, 0.1)',
              align: 'center'
            },
            {
              text: 'common.product_product-name',
              value: 'productName',
              sortable: false,
              width: '20%',
              class: 'rgba(151, 198, 234, 0.1)'
            },
            {
              text: 'product.product_supplier',
              value: 'supplier',
              sortable: false,
              width: '10%',
              class: 'rgba(151, 198, 234, 0.1)',
              align: 'center'
            },
            {
              text: 'common.product_capacity',
              value: 'product.capacity',
              sortable: false,
              width: '5%',
              class: 'rgba(151, 198, 234, 0.1)',
              align: 'center'
            },
            {
              text: 'storage.storage_stock-adjustt-quantity-rack-number',
              value: 'quantityAndStorageNoForStockAdjust',
              sortable: false,
              width: '9%',
              class: 'rgba(151, 198, 234, 0.1)',
              align: 'center'
            },
            {
              text: 'stock-adjust.stock-adjust_adjust-after-stock-cost',
              value: 'adjustAfterStockCost',
              sortable: false,
              width: '8%',
              class: 'rgba(151, 198, 234, 0.1)',
              align: 'center'
            }
          ],
          items: [],
          footers: [],
          itemKey: this.recItems.storageAdjustId
        },
        {
          title: 'sale.sale_note',
          name: 'test1',
          items: [],
          itemKey: ''
        }
      ]
    },
    async dialogReload() {
      this.$emit('submit')
      await this.init()
    },
    setDefaultRemarks() {
      if (!this.recItems.stockAdjustNote) {
        this.remarks = ''
        return
      }
      this.remarks = this.recItems.stockAdjustNote.body
    },
    async updateRemarks(...args) {
      const [text] = args
      const isConfirmed = confirm(
        this.$t('common.common_confirm-to-save-remarks')
      )
      if (!isConfirmed) return

      const isSucceed = await this.editStockAdjust({
        stockAdjustId: this.recItems.stockAdjustId,
        note: text
      })
      if (!isSucceed) return
      alert(this.$t('common.common_saved-alert'))
      this.$emit('submit')
    },
    async cancel(id) {
      const isConfirmed = confirm(`
${this.$t('stock-adjust.stock-adjust_stock-adjust-cancel-confirm')}

${this.$t('order.order_irreversible-confirm')}`)

      if (!isConfirmed) return
      const isSucceed = await this.cancelStockAdjust({
        stockAdjustId: this.recItems.stockAdjustId
      })
      if (isSucceed) {
        alert(this.$t('common.common_canceled-alert'))
        this.inputedValue.dialog = false
        this.$emit('submit')
      }
    }
  },
  created() {
    this.init()
  },
  computed: {
    ...mapGetters('User', ['authority']),
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  },
  watch: {
    'inputedValue.dialog': async function (val) {
      if (val) await this.init()
    },
    recItems: {
      handler(newVal, oldVal) {
        this.setDefaultRemarks()
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
<style lang="scss" scoped>
// .productTableCom {
//   ::v-deep .v-data-table th {
//     background-color: rgba(151, 198, 234, 0.1);
//     padding-left: 30px;
//   }
//   ::v-deep .v-data-table td {
//     padding-left: 30px;
//   }
// }
.normalNumberInput {
  width: 180px;
}
.stepComponent {
  width: 150px;
}
.btnStyle {
  width: 133px;
}
.productTableHeader {
  ::v-deep .v-data-table th {
    background-color: rgba(151, 198, 234, 0.1) !important;
    padding: 0 !important;
  }
}
</style>
